import styled, {css} from 'styled-components';

import breakpoints from '~constants/breakpoints';

type SliderButtonsProps = {
    color: 'white' | 'black';
    absolute?: boolean;
};

export const SliderButtons = styled.div<SliderButtonsProps>`
    color: ${({color}) => color};
    background-color: rgba(0, 0, 0, 0.03);
    display: flex;
    width: 141px;
    height: 34px;
    border-radius: 12px;
    ${({absolute}) =>
        absolute &&
        css`
            position: absolute;
            top: 64px;
            right: 25px;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(4px);
            color: white;
        `}
    ${breakpoints.phone} {
        right: 16px;
        width: 80px;
    }
    z-index: 2;
`;
